import XSensors from '@/utils/skynet';

export const isBybitTR = window.location?.host?.includes('.bybittr.com');

//  +new Date('2023-04-11T00:00:00') 方便现在测试
export const REGISTER_TIME =
  process.env.NEXT_PUBLIC_REGISTER_TIMESTAMP || '1681142400000';

// 合规站的kyc列表，后续迪拜等合规站留位置
export const ALL_SITE_LIST = ['HKG', 'ARE', 'BYBIT', 'NLD'];
export const FORCE_JUMP_HOST = ['NLD'];

// 主站标识
export const MAIN_SITE = 'BYBIT';
interface IRedirectModal {
  registrationOriginTime: {
    [key: string]: string;
  };
  // {
  //   "HKG": xxxx 时间戳
  //   "ARE": xxxx 时间戳
  // }
  kycCountry: string;
  registerTime: string;
  currentSite?: string;
}
export const getRealSite = (site = '') => {
  if (!site || !ALL_SITE_LIST?.includes(site)) {
    return MAIN_SITE;
  }
  return site;
};
export const getRedirectInfo = ({
  kycCountry: shouldVisitSite,
  currentSite,
}: IRedirectModal): any => {
  console.info(shouldVisitSite, currentSite, 'params');
  const result = {
    isNeedJump: false,
    jumpSite: shouldVisitSite,
  };

  if (isBybitTR) {
    return result;
  }
  if (getRealSite(shouldVisitSite) !== getRealSite(currentSite)) {
    result.isNeedJump = true;
  }
  if (shouldVisitSite === 'HKG' || currentSite === 'HKG') {
    result.isNeedJump = false;
  }
  return result;
};

export const showRedirectModal = ({
  currentSite,
  jumpSite,
  redirectUrl,
  onClose,
}: {
  // 'HKG' | 'BYBIT' | 'ARE' | 'NLD'
  currentSite: string;
  jumpSite: string;
  redirectUrl: string;
  onClose: () => void;
}) => {
  if (!window?.BybitUniFrame || !window?.BybitUniFrame?.complianceWall) {
    XSensors?.track('complianceWallLoadResult', {
      is_success: false,
    });
    onClose();
    return;
  }
  window?.BybitUniFrame.ready(({ complianceWall }: any) => {
    XSensors?.track('complianceWallLoadResult', {
      is_success: true,
    });
    complianceWall.showRedirectModal({
      jumpSite,
      redirectUrl,
      onClose,
      forceJump:
        FORCE_JUMP_HOST.includes(currentSite) ||
        FORCE_JUMP_HOST.includes(jumpSite),
      validHasKyc: true,
    });
  });
};
